import { useContent } from "contexts/contentContext/contentContext";
import { useNavigate } from "react-router-dom";
import { startTransition } from "react";

type HandleNavigateArgsT = {
  event: React.MouseEvent<HTMLAnchorElement, MouseEvent>;
  page?: string;
  fullUrl?: boolean;
  isNewTab?: boolean;
};

const useNavigateWithoutPageReload = () => {
  const { getPath } = useContent();
  const navigate = useNavigate();

  const handleNavigate = ({
    page,
    fullUrl,
    event,
    isNewTab,
  }: HandleNavigateArgsT) => {
    event.preventDefault();
    startTransition(() => {
      if (!page) return;
      if (fullUrl) {
        window.open(page, isNewTab ? "_blank" : "_self");
        return;
      }
      const newUrl = `${getPath()}${page}`;
      isNewTab ? window.open(newUrl, "_blank") : navigate(newUrl);
    });
  };

  return handleNavigate;
};

export default useNavigateWithoutPageReload;
